import { ADMIN, SUPER_ADMIN, MANAGE_PEOPLE } from "../permission.maps";

// types
/* oxlint-disable typescript/no-explicit-any */
import { TWorkflow } from "../typings";

export const DefaultTrainingWorkflow: TWorkflow = {
  _meta: {
    start: "default",
    end: "_done",
    _version: 2,
    nonLinearWorkflow: false,
    transitions: {
      "_create:default": {
        key: "_create:default",
        source: "_create",
        target: "default",
      },
      "default:_done": {
        key: "default:_done",
        source: "default",
        target: "_done",
      },
      "_done:default": {
        key: "_done:default",
        source: "_done",
        target: "default",
        skipValidation: true,
      },
    },
  },
  default: {
    name: "Default",
  },
  _done: {
    name: "Complete",
    _meta: {
      isResolution: true,
      nodeGuards: {
        permissions: [ADMIN.name, SUPER_ADMIN.name, MANAGE_PEOPLE.name],
      },
    },
  },
};

export const DefaultEquipmentWorkflow: TWorkflow = {
  _meta: {
    start: "done",
    end: "done",
    _version: 2,
    transitions: {
      "_create:done": {
        key: "_create:done",
        source: "_create",
        target: "done",
      },
    },
  },
  done: {
    name: "Done",
    _meta: {
      isResolution: true,
    },
  },
};

export const DefaultProjectWorkflow: TWorkflow = {
  _meta: {
    start: "done",
    end: "done",
    _version: 2,
    transitions: {
      "_create:done": {
        key: "_create:done",
        source: "_create",
        target: "done",
      },
    },
  },
  done: {
    name: "Done",
  },
};

export const DefaultApprovalWorkflow: TWorkflow = {
  _meta: {
    start: "in_prog",
    end: "approved",
    _version: 2,
    transitions: {
      "_create:in_prog": {
        key: "_create:in_prog",
        source: "_create",
        target: "in_prog",
      },
      "in_prog:in_review": {
        key: "in_prog:in_review",
        source: "in_prog",
        target: "in_review",
        stateAssignee: ["in_prog"],
      },
      "in_review:approved": {
        key: "in_review:approved",
        source: "in_review",
        target: "approved",
      },
    },
  },
  in_prog: {
    name: "In Progress",
  },
  in_review: {
    name: "Under Review",
    _meta: {
      nodeGuards: {
        permissions: [ADMIN.name, SUPER_ADMIN.name],
        stateAssignee: ["in_prog"],
        roles: [],
        userIds: [],
      },
    },
  },
  approved: {
    name: "Approved",
    _meta: {
      isResolution: true,
      nodeGuards: {
        permissions: [ADMIN.name, SUPER_ADMIN.name],
        roles: [],
        userIds: [],
      },
    },
  },
};

export const DefaultWorkflow: TWorkflow = {
  _meta: {
    start: "todo",
    end: "done",
    _version: 2,
    transitions: {
      "todo:in_prog": {
        source: "todo",
        target: "in_prog",
      },
      "in_prog:todo": {
        source: "in_prog",
        target: "todo",
      },
      "in_prog:done": {
        source: "in_prog",
        target: "done",
      },
      "done:in_prog": {
        source: "done",
        target: "in_prog",
      },
    },
  },
  todo: {
    name: "To-Do",
  },
  in_prog: {
    name: "In Progress",
  },
  done: {
    name: "Done",
    _meta: {
      isResolution: true,
    },
  },
};
